import styled from "styled-components";

export const Container = styled.div`
  z-index: 1;
  text-align: center;
  padding: 28px 0;
`;
